<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Edit Sound</v-card-title>

    <v-card-text>
        

        <v-row>

            <v-col>
                <v-select
                    label="Alert Sound"
                    :items=sound_choices
                    v-model="active_sound_choice"
                    v-on:change="onChangeAlertSound"
                    return-object
                />
            </v-col>

            <v-col class="flex-grow-0 align-self-center">

               <v-btn 
                    class="mx-2" fab small color="primary"
                    v-on:click="playSound"
                    :disabled="active_sound_choice.value == 'none'"
                >
                    <v-icon dark> mdi-play</v-icon>
                </v-btn>

            </v-col>

        </v-row>

        <v-checkbox
                label="Text personal device when a new conversation starts"
                v-model="text_personal_device_on_new_conversation"
                dense
            />
        
        <v-checkbox
                label="Text personal device when an idle conversation resumes"
                v-model="text_personal_device_on_new_message_in_idle_conversation"
                dense
            />

        <v-checkbox
                label="Text personal device when a voicemail is left"
                v-model="text_personal_device_on_new_voicemail"
                dense
            />

        <v-text-field
            label="Time after which a conversation is marked as idle"
            v-model="idle_conversation_threshold_in_minutes"
            type="number"
            autocomplete="off"
        />

         <v-checkbox
                label="Save notifications received during do not disturb times for later"
                v-model="save_notifications_during_dnd_for_later"
                dense
            />
                
    </v-card-text>


    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>

</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

const choice_none = {
                'url' : 'none',
                'text' : 'Do not play any sound',
                'value': 'none',
            };


export default {
    data() {
        return {
            dialog: false, 

            show_loading: false,
            sound_choices: [choice_none],
            active_sound_choice: choice_none,
            active_sound_choice_id: 'none',

            text_personal_device_on_new_conversation: false,
            text_personal_device_on_new_message_in_idle_conversation: false,
            idle_conversation_threshold_in_minutes: 0,
            save_notifications_during_dnd_for_later: false,
            text_personal_device_on_new_voicemail: false,
        }
    },

    methods: 
    {
        showDialog(profile) 
        {
            this.dialog = true;
            this.show_loading = true;
            this.active_sound_choice_id = profile.employee_account.in_app_notification_settings.alert_sound_id;

            this.text_personal_device_on_new_conversation = profile.employee_account.personal_notification_settings.text_personal_device_on_new_conversation;
            this.text_personal_device_on_new_message_in_idle_conversation = profile.employee_account.personal_notification_settings.text_personal_device_on_new_message_in_idle_conversation;
            this.idle_conversation_threshold_in_minutes = profile.employee_account.personal_notification_settings.idle_conversation_threshold_in_minutes;
            this.save_notifications_during_dnd_for_later = profile.employee_account.personal_notification_settings.save_notifications_during_dnd_for_later;
            this.text_personal_device_on_new_voicemail = profile.employee_account.personal_notification_settings.text_personal_device_on_new_voicemail;
            
            this.$rc.listAvailableAlertSounds(

                (sounds) => {
                    this.show_loading = false;
                    this.setSounds(sounds);
                },

                () => {
                    this.show_loading = false;
                    alert('Unable to load alert sounds.');
                    this.dialog = false;
                }
            );
        },

        setSounds(sounds)
        {
            let choices = [];

            choices.push(choice_none);

            for ( let i = 0; i < sounds.length; i++ )
            {
                choices.push({
                    'url' : sounds[i].url,
                    'text' : sounds[i].pretty_print_label,
                    'value' : sounds[i].blob_id,
                });

                if ( choices[i].value == this.active_sound_choice_id )
                {
                    this.active_sound_choice = choices[i]
                }
            }

            if ( this.active_sound_choice == null )
                this.active_sound_choice = choice_none; // no sound

            this.sound_choices = choices;
        },

        onChangeAlertSound(new_sound)
        {
            if ( new_sound.value === 'none' ) return;

            var audio = new Audio(new_sound.url);
            audio.play();
        },

        playSound()
        {
            if ( this.active_sound_choice == null ) return;
            if ( this.active_sound_choice.value == 'none' ) return;

            var audio = new Audio(this.active_sound_choice.url);
            audio.play();
        },
        
        onOk()
        {
           this.dialog = false;

           let changes = {
               'in_app_notification_settings' : {
                   'alert_sound_id' : this.active_sound_choice.value == 'none' ? null : this.active_sound_choice.value,
               },

               'personal_notification_settings' : {
                    'text_personal_device_on_new_conversation': this.text_personal_device_on_new_conversation,
                    'text_personal_device_on_new_message_in_idle_conversation': this.text_personal_device_on_new_message_in_idle_conversation,
                    'idle_conversation_threshold_in_minutes': this.idle_conversation_threshold_in_minutes,
                    'save_notifications_during_dnd_for_later': this.save_notifications_during_dnd_for_later,
                    'text_personal_device_on_new_voicemail': this.text_personal_device_on_new_voicemail,
               },

           };

           

            this.$emit('ok', changes);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>